<template>
    <div class="main pb-24 container mx-auto">
        <div class="w-full max-w-xs mx-auto">
            <h2 v-if="isQRCustomer" class="text-center p-5 pt-10 md:pt-16">{{ $t('CONFIRMATION_LOGIN_MSG') }}</h2>
            <h1 v-else class="text-center p-5 pt-10 md:pt-16">{{ $t('LOGIN_LOG_IN') }}</h1>
            <login-form></login-form>
            <h4 class="pl-3 mt-16 text-left">
                {{ $t('LOGIN_DO_NOT_HAVE') }}
            </h4>
            <div class="text-center container-padding">
                <router-link :to="{ name: 'register' }" class="btn btn--full-width btn--secondary-black btn--hoverable">
                    {{ $t('LOGIN_SIGN_UP') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import LoginForm from '@/components/forms/auth/LoginForm';

export default {
    name: 'Login',
    components: { LoginForm },
    mounted() {
        this.$store.dispatch('auth/resetAuth');
        this.$store.dispatch('account/resetAccount');
    },
    computed: {
        isQRCustomer() {
            return this.$globalQueryParams.uuid;
        },
    },
};
</script>

<style scoped>
    .container-padding {
        padding: 0.75rem;
    }
</style>
